import FormLabel from '@c/forms/controls/FormLabel';
import FormSelect from '@c/forms/controls/FormSelect';
import { zodResolver } from '@hookform/resolvers/zod';
import Button from '@ui/Button';
import { reportItem } from '@util/firestore/products';
import { REASONS, ReasonTypes } from '@util/maps/report-reasons';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import BaseModal from './BaseModal';

interface ReportItemModalProps {
  itemId: string;
  isUser: boolean;
  isOpen: boolean;
  dismiss: () => void;
}

const ReportItemModal = ({
  itemId,
  isUser,
  isOpen,
  dismiss,
}: ReportItemModalProps) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<{ reason: ReasonTypes }>({
    defaultValues: {
      reason: '',
    },
    resolver: zodResolver(z.object({ reason: z.string() })),
  });

  const onSubmit = ({ reason }: { reason: ReasonTypes }) => {
    reportItem(itemId, reason, isUser);
    dismiss();
  };

  const title = isUser ? 'Report a user' : 'Report an item';

  return (
    <>
      <BaseModal
        isOpen={isOpen}
        title={title}
        dismiss={dismiss}
        overflowType="visible"
        width="32rem"
      >
        <form onSubmit={handleSubmit(onSubmit)} className="w-full">
          <div className="flex flex-col gap-[2.4rem] text-brand-black">
            <FormLabel value="Select a reason" required>
              <FormSelect
                placeholder="Select..."
                control={control}
                error={!!errors.reason}
                options={REASONS}
                rules={{ required: true }}
                name="reason"
                onChange={() => console.log('select')}
                inModal={true}
              />
            </FormLabel>

            <span className="w-full whitespace-pre-wrap p-1 text-brand-gray">
              Our team will look into this as soon as possible. At GearFocus,
              we aim to create a safe enviornment for our community. You may not
              receive a reponse back regarding the issue.
            </span>
            <div className="flex justify-end gap-[1.2rem] font-semibold text-brand-secondary">
              <Button
                buttonType="button"
                type="text"
                text="Cancel"
                width="small"
                onClick={dismiss}
              />
              <Button buttonType="submit" type="secondary" text="Submit" />
            </div>
          </div>
        </form>
      </BaseModal>
    </>
  );
};

export default ReportItemModal;
